import { HTMLAttributes, memo, useMemo } from 'react';
import { useCurrentConversationValue } from 'hooks/business/conversation';
import TradePaymentAmountLazada from './TradeDetailPaymentLazada';
import TradePaymentAmountShopee from './TradeDetailPaymentShopee';
import TradeDetailIncomeShopee from './TradeDetailIncomeShopee';
import TradeDetailIncomeLazada from './TradeDetailIncomeLazada';
import TradeDetailNoData from './TradeDetailNoData';
import { TradeDetailPaymentTikTok } from './TradeDetailPaymentTikTok';
import TradeDetailIncomeAliExpress from './TradeDetailIncomeAliExpress';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import TradeDetailIncomeMercado from './TradeDetailIncomeMercado';
import { TradeDetailPaymentJolect } from './TradeDetailPaymentJolect';

export interface TradeDetailProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.TradeWithLogistics;
  exportMode?: boolean;
}

function TradeDetailPayIncome(props: TradeDetailProps) {
  const { trade, exportMode = false, ...otherProps } = props;

  const conversation = useCurrentConversationValue();

  const { channel } = conversation || {};

  const { paymentAmount, incomeAmount, incomeLazada } = useMemo(() => {
    const { totalAmount, customTradeIncome } = trade;

    let paymentAmount = <TradeDetailNoData />;
    let incomeLazada = null;
    let incomeAmount = <TradeDetailNoData />;

    const { buyerPayment, tradeIncome } = trade;

    if (totalAmount && channel === 'LAZADA') {
      paymentAmount = (
        <TradePaymentAmountLazada
          {...otherProps}
          key="TradePaymentAmountLazada"
          trade={trade}
          defaultFold={false}
          exportMode={exportMode}
          storeType={conversation?.topBarInfo?.storeType}
        />
      );
    }

    if (customTradeIncome?.length > 0 && channel === 'LAZADA') {
      incomeLazada = (
        <TradeDetailIncomeLazada
          {...otherProps}
          key="TradeDetailIncomeLazada"
          trade={trade}
          defaultFold={false}
        />
      );
    }

    if (buyerPayment && isTiKTokUpperCase(channel)) {
      paymentAmount = (
        <TradeDetailPaymentTikTok {...otherProps} key="TradeDetailPaymentTikTok" trade={trade} />
      );
    }

    if (channel === 'SHOPEE' && buyerPayment && tradeIncome) {
      incomeAmount = (
        <>
          <TradePaymentAmountShopee
            {...otherProps}
            key="TradePaymentAmountShopee"
            trade={trade}
            defaultFold={false}
          />
          <TradeDetailIncomeShopee
            {...otherProps}
            key="TradeDetailIncomeShopee"
            trade={trade}
            defaultFold={false}
          />
        </>
      );
    }

    if (channel === 'MERCADO') {
      incomeAmount = (
        <TradeDetailIncomeMercado
          {...otherProps}
          key="TradeDetailIncomeMercado"
          trade={trade}
          defaultFold={false}
        />
      );
    }

    if (channel === 'ALIEXPRESS' && tradeIncome) {
      incomeAmount = (
        <TradeDetailIncomeAliExpress
          {...otherProps}
          key="TradeDetailIncomeAliExpress"
          trade={trade}
          defaultFold={false}
        />
      );
    }

    if (channel === 'JOLECT') {
      paymentAmount = (
        <TradeDetailPaymentJolect {...otherProps} key="TradeDetailPaymentJolect" trade={trade} />
      );
      console.log('paymentAmount', paymentAmount);
    }

    return {
      paymentAmount,
      incomeAmount,
      incomeLazada,
    };
  }, [trade, channel, otherProps, conversation?.topBarInfo?.storeType, exportMode]);

  return (
    <div>
      {channel === 'TIKTOK' || channel === 'TIKTOK_US' ? paymentAmount : null}
      {channel === 'LAZADA' ? (
        <>
          {paymentAmount}
          {incomeLazada}
        </>
      ) : null}
      {channel === 'SHOPEE' ? incomeAmount : null}
      {channel === 'ALIEXPRESS' ? incomeAmount : null}
      {channel === 'MERCADO' ? incomeAmount : null}
      {channel === 'JOLECT' ? paymentAmount : null}
    </div>
  );
}

export default memo(TradeDetailPayIncome);
